<div class="carousel">
  @if (title()) {
  <div class="carousel__header">
    <h2 class="carousel__title">{{ title() }}</h2>
    @if (viewAllLink()) {
    <a class="carousel__view-all" [routerLink]="viewAllLink()" [queryParams]="viewAllQueryParams()">
      @if (title() === 'Más vendidos') {
      Ver todos
      } @else if (title() === 'Ofertas') {
      Ver todas
      } @else if (title() === 'Novedades') {
      Ver todas
      } @else {
      Ver todos
      }
      <app-icon [icon]="arrowRight" [size]="16" />
    </a>
    }
  </div>
  }

  <div
    class="carousel__wrapper"
    [class.carousel__wrapper--hover-arrows]="arrowsOnHover()"
    (mouseenter)="onWrapperMouseEnter()"
    (mouseleave)="onWrapperMouseLeave()"
    (focusin)="onWrapperFocusIn()"
    (focusout)="onWrapperFocusOut($event)"
    (touchstart)="onWrapperTouchStart()"
    (touchend)="onWrapperTouchEnd()"
  >
    <button class="carousel__arrow carousel__arrow--prev" type="button" aria-label="Anterior" (click)="scrollPrev()">
      <app-icon [icon]="chevronLeft" [size]="20" />
    </button>

    <div class="carousel__track" #track>
      @if (loading()) {
      @for (item of skeletonItems; track $index) {
      <div class="carousel__slot">
        <app-product-card-skeleton />
      </div>
      }
      } @else {
      @for (product of products(); track product.id) {
      <div class="carousel__slot">
        <app-product-card [product]="product"
          (addToCart)="addToCart.emit($event)"
          (reserveClick)="reserveClick.emit($event)"
          (zoomOpen)="zoomOpen.emit($event)"
          (notifyRequest)="notifyRequest.emit($event)"
          (notifyCancel)="notifyCancel.emit($event)"
          (cardClick)="cardClick.emit($event)" />
      </div>
      }
      @if (hasTrailingCta()) {
      <div class="carousel__slot carousel__slot--cta">
        <a class="carousel__cta" [routerLink]="trailingLink()">
          <span class="carousel__cta-label">{{ trailingLabel() }}</span>
          <app-icon [icon]="arrowRight" [size]="20" />
        </a>
      </div>
      }
      }
    </div>

    <button class="carousel__arrow carousel__arrow--next" type="button" aria-label="Siguiente" (click)="scrollNext()">
      <app-icon [icon]="chevronRight" [size]="20" />
    </button>
  </div>

  @if (showPagination() && !loading() && totalProducts() > 0) {
  <div class="carousel__pagination" role="tablist" aria-label="Navegación de productos">
    @for (product of products(); track product.id; let i = $index) {
    <button
      class="carousel__pagination-bar"
      [class.carousel__pagination-bar--active]="isBarActive(i)"
      [class.carousel__pagination-bar--visible]="isBarInView(i)"
      type="button"
      role="tab"
      [attr.aria-selected]="isBarActive(i)"
      [attr.aria-label]="'Ir al producto ' + (i + 1)"
      (click)="scrollToProduct(i)"
    ></button>
    }
  </div>
  }
</div>
